import React, { useState, useEffect } from "react";
import { getBNVaults } from "../../../networking/NetworkingOrders";
import MultipleSelect from "../../shared/MultipleSelect";
import { useVaultBalancesData } from "./useVaultBalancesData";
import { getStyle } from "../../../styles/styles";
import VaultBalanceNotationsGrid from "../../trade/VaultBalance/VaultBalanceNotationsGrid";

var style = getStyle()
const VaultBalance = () => {
    const [vaults, setVaults] = useState([])
    const [selectedVaults, setSelectedVaults] = useState([])

    const vaultId = selectedVaults.length > 0 ? selectedVaults[0].VaultId : null;
    const { columnsData, columnDetail, refresh } = useVaultBalancesData(vaultId);

    const fetchVaultsList = async () => {
        const response = await getBNVaults();
        if (response && response.response && response.response.data) {
            const vaultData = response.response.data.map(vault => ({
                VaultId: vault.VaultID,
                Description: vault.Description
            }))
            setVaults(vaultData);
        } else if (response && response.data) {
            const vaultData = response.data.map(vault => ({
                VaultId: vault.VaultID,
                Description: vault.Description
            }))
            setVaults(vaultData);
        } else {
            setVaults([]);
        }
    }

    useEffect(() => {
        fetchVaultsList();
    }, []);

    const onVaultsChange = (value) => {
        setSelectedVaults(value);
    }

    return(
        <div style={{
                width: 'auto',
                height: '80%',
                flexDirection: 'column',
                padding: 10,
                display: 'flex',
                alignItems: 'stretch',
                Margin:'0 auto'}}
        >
            <div
                className ='title-widget'
                style={{
                    display         : 'block',
                    textAlign       : 'center'
                }}>
                    <span>Vault Balances</span>
            </div>
            <div style={{display: 'flex'}}>
                <div className="uk-width-1-2" style={{textAlign: 'center'}}>
                    <label className="uk-form-label">Vault Selection</label>
                    <div className="" style={style.inputStyle}>
                        <MultipleSelect data={vaults} textField='Description' valueField='VaultId' onChange={onVaultsChange}/>
                    </div>
                </div>
            </div>
            {Array.isArray(columnsData) && columnsData.length > 0 ? (
                <VaultBalanceNotationsGrid columnsData={columnsData} columnDetail={columnDetail} />
            ) : (
                <div style={{ textAlign: 'center', marginTop: '40px', color: '#888' }}>No data to display</div>
            )}
        </div>
    )
};

export default VaultBalance;